import React, { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import { Spin } from 'antd';

const InvoiceProductListView = lazy(() => import('./views/InvoiceProductListView'));

export const invoiceProductRoutes: RouteObject[] = [
    {
        path: '/admin/invoice-products',
        element: (
            <Suspense fallback={<div className="flex justify-center p-8"><Spin /></div>}>
                <InvoiceProductListView />
            </Suspense>
        )
    }
];
